<template>
  <v-layout v-resize="onResize" column>
    <v-data-table
      flat
      :headers="headers"
      :items="resources"
      class="elevation-2"
      :loading="isLoading"
      :total-items="resourcesCount"
      :rows-per-page-items="limitOptions"
      :pagination.sync="pagination"
      :hide-headers="isMobile"
      :class="{ mobile: isMobile }"
    >
      <template slot="items" slot-scope="props">
        <tr v-if="!isMobile">
          <td class="text-xs-left">
            {{ $d(new Date(props.item.created_at), "short") }}
          </td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="text-xs-left">{{ $n(props.item.amount, "currency") }}</td>
          <td class="text-xs-left">
            <v-chip
              :class="setClass(props.item.status)"
              small
              text-color="white"
            >
              {{ $t(`status.${props.item.status}`) }}
            </v-chip>
          </td>
          <td><date-row :value="props.item.duedate" format="short" /></td>
          <td>
            <link-row route="invoice" text="Exibir" :id="props.item.id" />
          </td>
          <td class="text-xs-left">{{ props.item.installment_limit }}</td>
        </tr>
        <tr v-else>
          <td>
            <ul class="flex-content">
              <li class="flex-item" data-label="Data da Cobrança">
                {{ $d(new Date(props.item.created_at), "short") }}
              </li>
              <li class="flex-item" data-label="Nome">{{ props.item.name }}</li>
              <li class="flex-item" data-label="Email">
                {{ props.item.email }}
              </li>
              <li class="flex-item" data-label="Valor">
                {{ $n(props.item.amount, "currency") }}
              </li>
              <li class="flex-item" data-label="Status">
                <v-chip
                  :class="setClass(props.item.status)"
                  small
                  text-color="white"
                >
                  {{ $t(`status.${props.item.status}`) }}
                </v-chip>
              </li>
              <li class="flex-item" data-label="Vencimento">
                <date-row :value="props.item.duedate" format="short" />
              </li>
              <li class="flex-item" data-label="Detalhes">
                <link-row route="invoice" text="Exibir" :id="props.item.id" />
              </li>
              <li class="flex-item" data-label="Limite de Parcelas">
                {{ props.item.installment_limit }}
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";

export default {
  mounted() {
    this.$store.dispatch("invoices/load", this.filters);
  },
  computed: {
    ...mapGetters({
      resources: "invoices/list",
      resourcesCount: "invoices/resourcesCount",
      limitOptions: "invoices/limitOptions",
      currentPage: "invoices/currentPage",
      filters: "invoices/filter",
      isLoading: "invoices/loadingData",
    }),
    pages() {
      return 0;
    },
  },
  components: {
    paymentBrand: () => import("@/components/desktop/brand/PaymentBrand.vue"),
    NumericRow: () => import("./table/NumericRow.vue"),
    DateRow: () => import("./table/DateRow.vue"),
    LinkRow: () => import("./table/LinkRow.vue"),
    TextRow: () => import("./table/TextRow.vue"),
    ChipRow: () => import("./table/ChipRow.vue"),
    BrandRow: () => import("./table/BrandRow.vue"),
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch("invoices/load", this.filters);
      }
      if (changed(newPagination.page, oldPagination.page)) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch("invoices/load", this.filters);
      }
    },
  },
  methods: {
    ...mapActions({
      setCurrentPage: "invoices/setCurrentPage",
      setLimit: "invoices/setLimit",
    }),
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `invoice ${status}`;
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
  data() {
    return {
      items: [],
      isMobile: false,
      count: 0,
      pagination: {},
      headers: [
        { text: this.$t("phrases.invoiceDate"), value: "invoiceDate" },
        { text: this.$t("words.name"), value: "name" },
        { text: this.$t("words.email"), value: "email" },
        { text: this.$t("words.amount"), value: "amount" },
        { text: this.$t("status.status"), value: "status" },
        { text: this.$t("phrases.dueDate"), value: "dueDate" },
        { text: this.$t("words.detail"), value: "detail" },
        { text: this.$t("phrases.installmentLimit"), value: "install_limit" },
      ],
    };
  },
};
</script>
<style>
.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid #b2b2b8;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid #636366;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #636366;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
  margin-top: 10px;
}
.v-chip.invoice.cancelled {
  background-color: #b71c1c !important;
}
.v-chip.invoice.completed {
  background-color: #1b5e20 !important;
}
.v-chip.invoice.waiting {
  background-color: #ef6c00 !important;
}
</style>
